import { Box, CircularProgress, Typography } from '@mui/material'
import { FC } from 'react'
import { colorTokens } from '@/apps/legacy/shared/styles/colorTokens'

interface LoadingIndicatorProps {
  message?: string
  size?: number
}

export const LoadingIndicator: FC<LoadingIndicatorProps> = ({
  message = '読み込み中...',
  size = 40,
}) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: 2,
      p: 4,
    }}
  >
    <CircularProgress size={size} sx={{ color: colorTokens.grey[600] }} />
    <Typography
      sx={{
        color: colorTokens.grey[700],
      }}
    >
      {message}
    </Typography>
  </Box>
)
